export const DEVICE_NAMES = {
    APPLICATION: 'Aplikacja',
    CASH: 'Kasa',
    RVM: 'RVM'
}

export const DEVICE_TYPES = [
    {
        id: 'application',
        value: DEVICE_NAMES.APPLICATION,
        label: 'Aplikacja mobilna',
        device_type_subscriptions: 'md',
        img: 'application-device.svg'
    },
    {
        id: 'cash',
        value: DEVICE_NAMES.CASH,
        label: 'Kasa fiskalna',
        device_type_subscriptions: 'ecr',
        img: 'cash-device.svg'
    },
    {
        id: 'rvm',
        value: DEVICE_NAMES.RVM,
        label: 'Automat RVM',
        device_type_subscriptions: 'rvm',
        img: 'rvm-device.svg'
    }
]

export const LICENSE_STATE_NAMES = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE'
}

export const LICENSE_STATES = {
    [LICENSE_STATE_NAMES.ACTIVE]: {
        text: 'Aktywny',
        class: 'is-success'
    },
    [LICENSE_STATE_NAMES.INACTIVE]: {
        text: 'Nieaktywny',
        class: 'is-incompatible'
    }
}